export const UPDATE_MENU_NAVIGATION = '@@toyota/UPDATE_MENU_NAVIGATION';
export const SHOW_SECONDARY_MENU = '@@toyota/SHOW_SECONDARY_MENU';
export const TOGGLE_MENU_WIDTH = '@@toyota/TOGGLE_MENU_WIDTH';
export const ADD_ITEMS_TO_MENU = '@@toyota/ADD_ITEMS_TO_MENU';
export const ADDING_FAVORITE_OPTION = '@@toyota/ADDING_FAVORITE_OPTION';
export const ADDED_FAVORITE_OPTION = '@@toyota/ADDED_FAVORITE_OPTION';
export const ADDED_FAVORITE_OPTION_FAILED = '@@toyota/ADDED_FAVORITE_OPTION_FAILED';
export const GETTING_FAVORITE_OPTIONS = '@@toyota/GETTING_FAVORITE_OPTIONS';
export const GOTTEN_FAVORITE_OPTIONS = '@@toyota/GOTTEN_FAVORITE_OPTIONS';
export const GOTTEN_FAVORITE_OPTIONS_FAILED = '@@toyota/GOTTEN_FAVORITE_OPTIONS_FAILED';
export const REMOVING_FAVORITE_OPTION = '@@toyota/REMOVING_FAVORITE_OPTION';
export const REMOVED_FAVORITE_OPTION = '@@toyota/REMOVED_FAVORITE_OPTION';
export const REMOVED_FAVORITE_OPTION_FAILED = '@@toyota/REMOVED_FAVORITE_OPTION_FAILED';
export const PROCESSING_OPTION_POPULARITY = '@@toyota/PROCESSING_OPTION_POPULARITY';
export const PROCESSED_OPTION_POPULARITY = '@@toyota/PROCESSED_OPTION_POPULARITY';
export const PROCESSED_OPTION_POPULARITY_FAILED = '@@toyota/PROCESSED_OPTION_POPULARITY_FAILED';
export const GETTING_USER_OPTIONS = '@@toyota/GETTING_USER_OPTIONS';
export const GOTTEN_USER_OPTIONS = '@@toyota/GOTTEN_USER_OPTIONS';
export const GOTTEN_USER_OPTIONS_FAILED = '@@toyota/GOTTEN_USER_OPTIONS_FAILED';
